<wchfs-icon svgIcon="pso:weather_m" color="supporting-3" size="24"></wchfs-icon>
<span class="name">{{ adhesion | uppercase }}</span>
